module.exports = __webpack_public_path__ + "img/1795312712372871170.e927e326.gif";